'use client'

import React from 'react'
import { AppLoadingScreen } from './AppLoadingScreen'
import styles from './feedback.module.css'

interface SafeLoadingOverlayProps {
  visible?: boolean
  tip?: string
  /** @deprecated ignored — canonical spinner is primary rose gold only */
  variant?: string
  size?: 'md' | 'lg' | 'xl' | number
}

/**
 * Optional full-viewport overlay using the canonical AppLoadingScreen language.
 * Default visible=false so the shell never stacks an extra splash on mount.
 */
export function SafeLoadingOverlay({
  visible = false,
  tip,
  size = 'lg',
}: SafeLoadingOverlayProps) {
  if (!visible) return null

  const spinnerSize: 'md' | 'lg' | 'xl' =
    size === 'md' || size === 'lg' || size === 'xl' ? size : 'lg'

  return (
    <div className={styles.overlay} aria-hidden={false}>
      <AppLoadingScreen
        message={tip || 'Loading…'}
        variant="inline"
        size={spinnerSize}
      />
    </div>
  )
}

export default SafeLoadingOverlay
